import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M7 12h13","key":"svg-1"}],["path",{"d":"M10 18h10","key":"svg-2"}]]

/**
 * IconMenuDeep
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWVudS1kZWVwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDZoMTYiIC8+CiAgPHBhdGggZD0iTTcgMTJoMTMiIC8+CiAgPHBhdGggZD0iTTEwIDE4aDEwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/menu-deep
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMenuDeep = createReactComponent('outline', 'menu-deep', 'MenuDeep', __iconNode);

export default IconMenuDeep;